import PropTypes from 'prop-types';
import { useMemo } from 'react';

function LicencePlate({
  style,
  className,
  country,
  licence = '',
  sizePx = 150,
}) {
  const widthPx = sizePx;
  const heightPx = Math.floor(sizePx * 11 / 52);
  const fontPx = Math.floor(0.8 * heightPx);
  const radiusPx = Math.floor(sizePx / 30);
  const framePx = Math.floor(sizePx / 50);
  const insideHeightPx = heightPx - (2 * framePx);

  const backgroundColor = useMemo(
    () => {
      switch (country) {
        case 'fr': return '#FFFFFF';
        case 'lu': return '#FBBC01';
        case 'uk': return '#F8EB3E';
        default: return '#FFFFFF';
      }
    },
    [country],
  );

  const frameColor = useMemo(
    () => {
      switch (country) {
        case 'be': return '#E00000';
        // case 'fr': return '#000000';
        // case 'lu': return '#000000';
        case 'uk': return '#F8EB3E';
        default: return '#000000';
      }
    },
    [country],
  );

  const textColor = useMemo(
    () => {
      switch (country) {
        case 'be': return '#E00000';
        // case 'fr': return '#000000';
        // case 'lu': return '#000000';
        // case 'uk': return '#000000';
        default: return '#000000';
      }
    },
    [country],
  );

  return (
    <div
      className={`flex justify-center items-center relative px-1.5 ${className || ''}`}
      style={{
        height: `${heightPx}px`,
        minHeight: `${heightPx}px`,
        minWidth: `${widthPx}px`,
        border: `${framePx}px solid ${frameColor}`,
        borderRadius: `${radiusPx}px`,
        backgroundColor,
        ...style,
      }}
    >
      <span
        style={{
          height: `${insideHeightPx}px`,
          lineHeight: `${insideHeightPx}px`,
          width: '100%',
          textAlign: 'center',
          verticalAlign: 'middle',
          color: textColor,
          backgroundColor,
          fontFamily: 'Courier New',
          fontSize: `${fontPx}px`,
          fontWeight: 700, // bold
        }}
      >
        {licence}
      </span>
    </div>
  );
}

LicencePlate.propTypes = {
  style: PropTypes.shape({ }),
  className: PropTypes.string,
  country: PropTypes.string,
  licence: PropTypes.string,
  sizePx: PropTypes.number,
};

export default LicencePlate;
